import { IPublicClientApplication } from "@azure/msal-browser"
import { getToken } from "Components/Functions";
import { api } from "./apiConfig"

export const PaymentAPI = {
    getAll: async function (instance: IPublicClientApplication,bookingId: number) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `Payment/GetBookingPayments?booking_id=${bookingId}`,
            method: "GET",
            headers: { Authorization: header }
        })
        return response.data
    },
    process: async function (instance: IPublicClientApplication, bookingId: number, paymentValue: number, newBooking: boolean) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: `Payment/ProcessPayment?booking_id=${bookingId}&payment_value=${paymentValue}&new_booking=${newBooking}`,
            method: "POST",
            headers: { Authorization: header }
        })
        return response.data
    }
}